import React from 'react';
import styled from 'styled-components';
import ActionButton from '../ActionButton';
import FixterBin from './IconDelete';

const Button = styled(ActionButton)`
  &.ant-btn {
    &,
    &:hover,
    &:active,
    &:focus {
      color: #1890ff;
      background: none;
      border: none;
      box-shadow: none;
    }
    > * {
      vertical-align: middle;
    }
  }
`;

export default function DeleteButton({ ...props }) {
  return (
    <Button {...props} ><FixterBin /></Button>
  );
}
